export const CheckboxType = {
  Black: "black",
};
